// extracted by mini-css-extract-plugin
export default {"sliderContainer":"range-slider_sliderContainer__JsmlC","sliderLabel":"range-slider_sliderLabel__Uu4Il","value":"range-slider_value__oibUz","range":"range-slider_range__sfpKl"};